var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.clientType == 'pc')?_c('HomePC'):_vm._e(),(_vm.clientType == 'mobile')?_c('HomeMobile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }